import { SortByEnum } from './enums';
import { CoachesType } from './types';

export const sortCoaches = (coaches: CoachesType, sortBy: SortByEnum): CoachesType => {
  switch (sortBy) {
    case SortByEnum.Followers:
      return coaches.sort(
        (a, b) =>
          (b.followersAggregate?.aggregate?.count || 0) -
          (a.followersAggregate?.aggregate?.count || 0),
      );
    case SortByEnum.PriceLowHigh:
      return coaches.sort(
        (a, b) =>
          (a.priceUnitAmountRemoteCoachDefault || 0) - (b.priceUnitAmountRemoteCoachDefault || 0),
      );
    case SortByEnum.PriceHighLow:
      return coaches.sort(
        (a, b) =>
          (b.priceUnitAmountRemoteCoachDefault || 0) - (a.priceUnitAmountRemoteCoachDefault || 0),
      );
    default:
      return coaches;
  }
};

export const sortOptions = [
  { label: 'Followers', value: SortByEnum.Followers },
  { label: 'Price Low-High', value: SortByEnum.PriceLowHigh },
  { label: 'Price High-Low', value: SortByEnum.PriceHighLow },
  { label: 'Distance', value: SortByEnum.Distance },
];
